
export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white relative overflow-hidden">
      {/* Subtle background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-slate-800/30 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-slate-700/30 rounded-full blur-3xl translate-x-40 translate-y-40"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/04006df53a08ec1734772add04ba0dab.jpg"
                  alt="Goodwin Developments Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <div className="flex flex-col">
                <h3 className="text-xl font-bold text-white leading-tight">
                  Goodwin Developments
                </h3>
              </div>
            </div>
            <p className="text-slate-300 mb-8 leading-relaxed max-w-md">
              Building generational wealth through furnished rentals, property management, and investment guidance. Your trusted partner in real estate success.
            </p>
            <div className="flex space-x-6">
              <a href="#" className="w-12 h-12 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 bg-slate-800 hover:bg-slate-700 rounded-lg flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-4">
              <li>
                <a href="#home" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-arrow-right-s-line mr-2"></i>
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-arrow-right-s-line mr-2"></i>
                  Services
                </a>
              </li>
              <li>
                <a href="#rentals" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-arrow-right-s-line mr-2"></i>
                  Rentals
                </a>
              </li>
              <li>
                <a href="#about" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-arrow-right-s-line mr-2"></i>
                  About
                </a>
              </li>
              <li>
                <a href="#contact" className="text-slate-300 hover:text-white transition-colors duration-300 cursor-pointer flex items-center">
                  <i className="ri-arrow-right-s-line mr-2"></i>
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-6 h-6 bg-slate-800 rounded-lg flex items-center justify-center mr-3 mt-1">
                  <i className="ri-map-pin-fill text-slate-300 text-sm"></i>
                </div>
                <span className="text-slate-300">3 Woodland Drive<br />Greenwich, CT 06830</span>
              </li>
              <li className="flex items-center">
                <div className="w-6 h-6 bg-slate-800 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-phone-fill text-slate-300 text-sm"></i>
                </div>
                <span className="text-slate-300">(203) 536-3764 / (203) 390-1188</span>
              </li>
              <li className="flex items-center">
                <div className="w-6 h-6 bg-slate-800 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-mail-fill text-slate-300 text-sm"></i>
                </div>
                <span className="text-slate-300">goodwin.developments.llc@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-400 text-sm mb-4 md:mb-0">
            © 2024 Your Company Name. All rights reserved.
          </p>
          <div className="flex items-center space-x-6">
            <a href="#" className="text-slate-400 hover:text-slate-300 text-sm transition-colors duration-300 cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-slate-400 hover:text-slate-300 text-sm transition-colors duration-300 cursor-pointer">
              Terms of Service
            </a>
            <a href="https://readdy.ai/?origin=logo" className="text-slate-400 hover:text-slate-300 text-sm transition-colors duration-300 cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
